import React from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';

import '../style/PublishBanner.css';

export default ({ handlePublishOpen, handleRequestOpen, handleInitialClose }) => {
  return (
    <Modal className="modal-container initial-modal" open dimmer="inverted">
      <Modal.Header>
        <Button
          id="inside-close-icon"
          className="inside-close-icon"
          onClick={handleInitialClose}
          icon
        >
          <Icon name="close" />
        </Button>
      </Modal.Header>
      <Modal.Content className="initial-modal-content">
        <h2>
          Click Sign Up to make content edits directly, get a free domain, and take your website
          live.
        </h2>
        <br />
        <Button onClick={handlePublishOpen} className="payment-publish-button">
          Sign Up
        </Button>
        <br />
        <div style={{ marginTop: '1em', fontSize: '1.25em' }}>
          Or{' '}
          <span
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={handleRequestOpen}
          >
            request an edit
          </span>{' '}
          to your website
        </div>
      </Modal.Content>
    </Modal>
  );
};
